import React, { useEffect, useRef } from "react";
import StaticAlertBanner from "../generic/StaticAlertBanner";
import { MESSAGE_TYPES, MessageType } from "../../constants/Messages";

interface SharedAlertHandlerProps {
    successAlert: { message: string; type?: MessageType; title?: string; isHtml?: boolean } | null;
    errorAlert: { message: string; type?: MessageType; title?: string; isHtml?: boolean } | null;
    onCloseSuccess: () => void;
    onCloseError: () => void;
}

const SharedAlertBanner: React.FC<SharedAlertHandlerProps> = ({
                                                                  successAlert,
                                                                  errorAlert,
                                                                  onCloseSuccess,
                                                                  onCloseError,
                                                              }) => {
    const successRef = useRef<HTMLDivElement | null>(null);
    const errorRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (successAlert && successRef.current) {
            // Scroll to success if it exists
            successRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (errorAlert && errorRef.current) {
            // Scroll to error only if no success
            errorRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [ successAlert, errorAlert ]);

    return (
        <>
            {successAlert?.message && (
                <div ref={successRef}>
                    <StaticAlertBanner
                        message={successAlert.message}
                        message_type={successAlert.type || MESSAGE_TYPES.SUCCESS}
                        onClose={onCloseSuccess}
                        title={successAlert.title}
                        isHtml={successAlert.isHtml}
                    />
                </div>
            )}
            {errorAlert?.message && (
                <div ref={errorRef}>
                    <StaticAlertBanner
                        message={errorAlert.message}
                        message_type={errorAlert.type || MESSAGE_TYPES.ERROR}
                        onClose={onCloseError}
                        title={errorAlert.title}
                        isHtml={errorAlert.isHtml}
                    />
                </div>
            )}
        </>
    );
};

export default SharedAlertBanner;
